import { useTranslation } from 'react-i18next';

import { Form, Input, Message, Modal } from '@arco-design/web-react';
import type { FormInstance } from '@arco-design/web-react/es/Form';

import { MAAS_INPUT_PLACEHOLDER, maasRequiredRules } from '@/delivery-type-plugin/capabilities/maas-init/form-messages';
import type { MaasModelSourceType, MaasOptions } from '@/delivery-type-plugin/capabilities/maas-init/maasTypes';
import { getModalPopupContainer } from '@/delivery-type-plugin/utils/modalPopupContainer';

import { getCreateStorageModalModelRules, validateAddModelModalFields } from './model-source-form-rules';
import ModelSourceSetting from './model-source-setting';
import sourceStyles from './model-source-setting.module.less';

const FormItem = Form.Item;

interface ModelConfigureModalProps {
  open: boolean;
  form: FormInstance;
  typeOptions?: MaasOptions;
  lockedSourceType?: MaasModelSourceType;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
}

/** 添加新模型：来源 + 服务名称 + 大小（不含模型类型） */
export function ModelConfigureModal({ open, form, typeOptions, lockedSourceType, onClose, onConfirm }: ModelConfigureModalProps) {
  const { t } = useTranslation();
  const modelRules = getCreateStorageModalModelRules(form);

  return (
    <Modal
      visible={open}
      title={t('data-center:maas.add.model')}
      onCancel={onClose}
      onOk={async () => {
        try {
          await validateAddModelModalFields(form);
        } catch (error) {
          Message.error(error instanceof Error ? error.message : String(error));
          throw error;
        }
        await onConfirm();
      }}
      unmountOnExit
      getPopupContainer={getModalPopupContainer}
    >
      <Form form={form} layout="vertical" className={sourceStyles.modalForm}>
        <FormItem
          label={t('data-center:maas.model.select')}
          field="model.source"
          required
          rules={modelRules}
          className={sourceStyles.modelSourceField}
        >
          <ModelSourceSetting form={form} typeOptions={typeOptions} lockedSourceType={lockedSourceType} />
        </FormItem>
        <FormItem
          label={t('data-center:maas.service.name')}
          field="model.name"
          rules={maasRequiredRules(t('data-center:maas.service.name'))}
        >
          <Input placeholder={MAAS_INPUT_PLACEHOLDER} />
        </FormItem>
        <FormItem label={t('data-center:maas.model.size')} field="model.size" rules={maasRequiredRules(t('data-center:maas.model.size'))}>
          <Input placeholder="10Gi" />
        </FormItem>
      </Form>
    </Modal>
  );
}
